import * as React from "react";
const SvgRecraft = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "#181B25" }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11089_15419)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.8335 8.1375C13.8335 5.8525 11.7585 4 9.1985 4C8.3115 4 7.592 5.8525 7.592 8.1375C7.592 8.709 7.637 9.254 7.7185 9.7495H6.145L4.5 15.5H9.2V12.2765C11.7585 12.2765 13.833 10.423 13.833 8.139L13.8335 8.138V8.1375ZM9.1985 4.7575C9.6635 4.7575 10.0395 6.2715 10.0395 8.1375C10.0395 10.004 9.6635 11.5175 9.199 11.5175C8.734 11.5175 8.3585 10.004 8.3585 8.1375C8.3585 6.2715 8.7345 4.7575 9.1985 4.7575Z",
      fill: "white"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.924 12.276H9.20399L11.014 15.5H15.733L13.924 12.276Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11089_15419" }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4 4)" })))
);
export default SvgRecraft;
